import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/query_container_outcomes/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchOrgInvoice(agro_exporter_id, org_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/query_container_outcomes/show_org_invoice/${agro_exporter_id}/fetch_org_invoice/${org_invoice_id}`
    );
  },

  fetchOrgInvoicePayments(agro_exporter_id, org_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/query_container_outcomes/show_org_invoice/${agro_exporter_id}/fetch_org_invoice_payments/${org_invoice_id}`
    );
  },

  fetchOrgInvoiceDiscounts(agro_exporter_id, org_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/query_container_outcomes/show_org_invoice/${agro_exporter_id}/fetch_org_invoice_discounts/${org_invoice_id}`
    );
  }
}
